import { inject } from "@angular/core";
import { CanActivateFn, Router, UrlTree } from "@angular/router";
import { canAccessAdvancedSurfaces } from "@ramudden/models/user";
import { AuthenticationService } from "../services/authentication.service";
import { GlobalStateService } from "../services/global-state.service";

/**
 * Keeps the Groups, Data, Scenarios and History screens out of reach of organizations whose users do not get them,
 * so a bookmark or a hand-typed URL cannot land on a screen whose navigation entry is hidden. Denied users are sent
 * to their first available screen, the same way authorizationGuard resolves a refusal.
 */
export const advancedSurfacesAccessGuard: CanActivateFn = (): boolean | UrlTree => {
    const router = inject(Router);
    const globalStateService = inject(GlobalStateService);
    const authenticationService = inject(AuthenticationService);

    if (canAccessAdvancedSurfaces(globalStateService.getAuthorizationInfo())) {
        return true;
    }

    const availableLink = authenticationService
        .getNavigationLinks(globalStateService.getCurrentRights())
        .takeFirstOrDefault();
    if (!availableLink) {
        return false;
    }

    return router.parseUrl(availableLink.route);
};
